/* Carbon look — shared behaviour: scroll reveal, sliders, marquee cloning, video modal. */
(function () {
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.cb-reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        setTimeout(function () { el.classList.add('is-visible'); }, parseInt(el.dataset.cbDelay || 0, 10));
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Fill a marquee with enough copies of its track to cover the viewport twice. */
  function initMarquees(root) {
    (root || document).querySelectorAll('[data-cb-marquee]').forEach(function (m) {
      if (m.dataset.cbReady) return;
      var track = m.querySelector('.cb-marquee__track');
      if (!track) return;
      m.dataset.cbReady = '1';
      var copies = Math.max(1, Math.ceil(window.innerWidth / Math.max(track.scrollWidth, 1)));
      for (var i = 0; i < copies; i++) {
        var clone = track.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a, button').forEach(function (n) { n.setAttribute('tabindex', '-1'); });
        m.appendChild(clone);
      }
    });
  }

  function initSliders(root) {
    (root || document).querySelectorAll('[data-cb-slider]').forEach(function (wrap) {
      if (wrap.dataset.cbReady) return;
      wrap.dataset.cbReady = '1';
      var list = wrap.querySelector('.cb-slider');
      var prev = wrap.querySelector('[data-cb-prev]');
      var next = wrap.querySelector('[data-cb-next]');
      var bar = wrap.querySelector('.cb-progress__bar');
      if (!list) return;
      function step() {
        var item = list.firstElementChild;
        if (!item) return list.clientWidth;
        var gap = parseFloat(getComputedStyle(list).columnGap) || 0;
        return item.getBoundingClientRect().width + gap;
      }
      function update() {
        var max = list.scrollWidth - list.clientWidth;
        if (prev) prev.disabled = list.scrollLeft <= 2;
        if (next) next.disabled = list.scrollLeft >= max - 2;
        if (bar) {
          var visible = Math.min(1, list.clientWidth / Math.max(list.scrollWidth, 1));
          bar.style.width = (visible * 100) + '%';
          var pos = max > 0 ? list.scrollLeft / max : 0;
          bar.style.transform = 'translateX(' + (pos * (1 / visible - 1) * 100) + '%)';
        }
      }
      if (prev) prev.addEventListener('click', function () { list.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { list.scrollBy({ left: step(), behavior: 'smooth' }); });
      list.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* Video feed: clicking a post opens it large with its linked product. */
  function initVideoModal(root) {
    (root || document).querySelectorAll('[data-cb-feed]').forEach(function (feed) {
      if (feed.dataset.cbReady) return;
      feed.dataset.cbReady = '1';
      var modal = feed.querySelector('.cb-feed-modal');
      if (!modal) return;
      var stage = modal.querySelector('.cb-feed-modal__media');
      var info = modal.querySelector('.cb-feed-modal__info');
      function close() {
        modal.hidden = true;
        stage.innerHTML = '';
        info.innerHTML = '';
        document.body.style.overflow = '';
      }
      feed.addEventListener('click', function (e) {
        var post = e.target.closest('[data-cb-post]');
        if (post) {
          var tpl = feed.querySelector('template[data-cb-post-tpl="' + post.dataset.cbPost + '"]');
          if (!tpl) return;
          var frag = tpl.content.cloneNode(true);
          stage.appendChild(frag.querySelector('[data-cb-media]'));
          var details = frag.querySelector('[data-cb-info]');
          if (details) info.appendChild(details);
          modal.hidden = false;
          document.body.style.overflow = 'hidden';
          var v = stage.querySelector('video');
          if (v) { v.muted = false; v.play().catch(function () { v.muted = true; v.play(); }); }
          modal.querySelector('.cb-feed-modal__close').focus();
          return;
        }
        if (e.target.closest('[data-cb-close]')) close();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
    });
  }

  function initAll(root) {
    initMarquees(root);
    initSliders(root);
    initVideoModal(root);
    initReveal(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
